import createReactComponent from '../createReactComponent';
var PenTool = createReactComponent('PenTool', [['path', {
  d: 'M12 19l7-7 3 3-7 7-3-3z',
  key: '1tojkb'
}], ['path', {
  d: 'M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z',
  key: 'qcwynw'
}], ['path', {
  d: 'M2 2l7.586 7.586',
  key: 'y56u2j'
}], ['circle', {
  cx: '11',
  cy: '11',
  r: '2',
  key: 'xmgehs'
}]]);
export default PenTool;